import {getRandomInt} from "js/randomNumber"

document.querySelectorAll<HTMLImageElement>(".c-desc-decoration img").forEach((decoration) => {
  decoration.src = decoration.src.replace("line_01.svg", `line_0${getRandomInt(1, 7)}.svg`)
  decoration.classList.add("--show")
})
